import { render, staticRenderFns } from "./TeaserArticlesHome.vue?vue&type=template&id=4518882f"
import script from "./TeaserArticlesHome.vue?vue&type=script&lang=ts"
export * from "./TeaserArticlesHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports